import { gql } from "@apollo/client";
import { PDR_HISTORY_FRAGMENT } from "../fragments";

export const PDR_HISTORY_DETAILS_QUERY = gql`
  query GetPdrHistoryDetails($id: ID!) {
    pdrHistoryDetails(id: $id) {
      ...PDRHistoryFragment
    }
  }
  ${PDR_HISTORY_FRAGMENT}
`;
